<template>
  <div class="evaluate">
    <div class="flex_box">
      <div class="left">
        <div class="left_title">How is the APP</div>
        <div class="left_title">rated?</div>
        <div class="left_img">
          <img src="@/assets/good.png" alt="">
        </div>
      </div>
      <div class="right">
        <SlickCarousel style="width: 100%" v-bind='slickOptions'>
          <div class="carousel-column" v-for="(item, index) in carouselList" :key="index">
            <div class="item">
              <div class="stars">
                <img src="../assets/stars.png" alt="">
              </div>
              <div class="text">{{ item.text }}</div>
              <div class="person">
                <div class="header">
                  <img :src="item.header" alt="">
                </div>
                <div class="name">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </SlickCarousel>
        <!-- <div class="btns">
          <div class="btn_left">
            <img src="../assets/Carousel_left.png" alt="">
          </div>
          <div class="btn_right">
            <img src="../assets/Carousel_right.png" alt="">
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import SlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  components: {
    SlickCarousel
  },
  data() {
    return {
      carouselList: [
        {
          text: 'The approval was very fast! I got the loan right after I submitted my personal information.',
          name: 'Alvin Rob',
          header: require('@/assets/person1.png'),
        },{
          text: 'This app recommended by a friend quickly solved the funding needs. The loan amount is very high and the loan is released very quickly. It is worth recommending to friends in need.',
          name: 'Felix Judd',
          header: require('@/assets/person2.png'),
        },{
          text: 'It is very convenient to use. I registered my mobile number, filled in the basic information, and waited for a while to check that the loan had been credited to my wallet. The speed was very fast.',
          name: 'Marlon Robert',
          header: require('@/assets/person3.png'),
        }
      ],
      slickOptions: {
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        dots: false,
      }
    };
  },
}
</script>

<style lang="scss" scoped>
.evaluate {
  margin-top: 223px;
  width: 100%;
  padding: 0 178px;
  box-sizing: border-box;
  .flex_box {
    display: flex;
    padding: 40px 72px;
    height: 507px;
    box-sizing: border-box;
    background: url('../assets/eva_bg.png') 0 0 no-repeat;
    background-size: 100% 100%;
    .left {
      width: 388px;
      margin-right: 47px;
      flex-shrink: 0;
      .left_title {
        font-family: 'Lexend_Medium';
        font-weight: 500;
        font-size: 39px;
        color: #FFFFFF;
        line-height: 51px;
      }
      .left_img {
        margin: 56px auto 0;
        width: 187px;
        height: 187px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .right {
      width: 809px;
      .carousel-column {
        padding: 8.5px;
        .item {
          background-color: #FFFFFF;
          border-radius: 13px;
          width: 396px;
          height: 346px;
          padding: 36px 28px;
          margin-right: 17px;
          box-sizing: border-box;
          position: relative;
          .stars {
            width: 120px;
            height: 18px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .text {
            margin-top: 21px;
            font-family: 'Lexend_Regular';
            font-weight: 400;
            font-size: 17px;
            color: #1F1D0D;
            line-height: 24px;
            height: 189px;
          }
          .person {
            display: flex;
            .header {
              width: 63px;
              height: 63px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .name {
              font-family: 'Lexend_Bold';
              font-weight: bold;
              font-size: 17px;
              color: rgba(57,73,77,0.16);
              line-height: 63px;
              margin-left: 13px;
            }
          }
        }
      }
      .btns {
        display: flex;
        margin-top: 25px;
        .btn_left,
        .btn_right {
          width: 51px;
          height: 51px;
          cursor: pointer;
          margin-right: 11px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/evaluate.vue